export const defaultTimezone = 'America/Los_Angeles';
export const lsPrefix = 'HERO_';
export const defaultOrganizationName = 'Lemonlight';
export const heroSupportEmail = 'support@lemonlight.com';
